import { BookOpenIcon, EyeIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface MethodStep {
  n: string;
  title: string;
  icon: LucideIcon;
  text: string;
}

export const methodSteps: MethodStep[] = [
  {
    n: '1',
    title: 'Abre',
    icon: BookOpenIcon,
    text: 'Elige la sesión o el aspecto que quieres trabajar (técnica, táctica K1-K2, física).'
  },
  {
    n: '2',
    title: 'Mira',
    icon: EyeIcon,
    text: 'Consulta la organización, el diagrama y las correcciones. Fichas de ejercicio en una página y sesiones completas desarrolladas en dos páginas.'
  },
  {
    n: '3',
    title: 'Entrena',
    icon: DumbbellIcon,
    text: 'Ajusta el montaje a tus jugadores y al espacio disponible, y lleva la sesión a la pista.'
  }
];
